import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { TriOptionsModel } from '../../../../../../../FrontDeskModule/Shared/components/FrontDeskToolbar';
import { DepartureReportFormModel, DepartureReportStateEnum } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): DepartureReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  card_ids: [],
  rate_ids: [],
  room_type_ids: [],
  balance: false,
  state: DepartureReportStateEnum.DUE_OUT,
  nationality_ids: null,
  sortBy: TriOptionsModel.departure_time,
  sortDirection: 'asc',
  grouped: true,
  exclude_partial: false,
  file_type: 'pdf',
});
